export const ADMIN_EMAILS = ["stepan.p@gmail.com", "joeaverbukh@gmail.com"];
export const COHORT_1 = "c01";
export const COHORT_2 = "c02";
export const COHORTS = [COHORT_1, COHORT_2];
